import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { sendAllMessages as s } from './sendAllMessages';
import type { SendAllFooter, SendAllLead as Lead } from './sendAllModel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Send to all sheet; each part uses its own slice of it */
import styles from './SendAll.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SendAllLeadProps {
  lead: Lead;
  failed: number;
  footer: SendAllFooter;
}

/** The "Sending" banner (design c3) and the lead line of "We send it for you" (c1–c5). */
const SendAllLeadComponent: React.FC<SendAllLeadProps> = ({ lead, failed, footer }) => {
  const intl = useIntl();
  let text = intl.formatMessage(s.leadPick);
  if (lead === 'noneConnected') {
    text = intl.formatMessage(s.leadNoneConnected);
  } else if (lead === 'working') {
    text = intl.formatMessage(s.leadWorking);
  } else if (lead === 'allLive') {
    text = intl.formatMessage(s.leadAllLive);
  } else if (lead === 'someFailed') {
    text = intl.formatMessage(s.leadSomeFailed, { count: failed });
  }

  return (
    <>
      {footer.kind === 'working' && (
        <div className={styles.banner} role="status" data-testid="send-all-banner">
          <span className="flex-grow-1">{intl.formatMessage(s.banner, { count: Math.max(1, footer.services) })}</span>
          <span className={styles.progress} aria-hidden="true">
            <i className={styles.progressBar} />
          </span>
        </div>
      )}
      <div className={styles.lead}>
        <span className={styles.leadTitle}>{intl.formatMessage(s.weSend)}</span>
        <span className={styles.itemSub} data-testid="send-all-lead">
          {text}
        </span>
      </div>
    </>
  );
};

export const SendAllLead = TypedMemo(SendAllLeadComponent);
